import React, { useState } from "react";
import {
  Home2,
  ProfileCircle,
  CallCalling,
  Box,
  LogoutCurve,
} from "iconsax-react";
import "./Navbar.css";
import { useNavigate, useParams } from "react-router-dom";

const Navbar = ({ admin = false }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="navbar text-white py-0">
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center h-[72px] overflow-hidden">
        <div className="relative w-[72px] h-[72px] flex-shrink-0 overflow-visible">
          <img
            src="/gms.png"
            alt="Logo"
            className="absolute inset-0 w-full h-full object-contain scale-[1.5] origin-center cursor-pointer drop-shadow-lg contrast-150 brightness-110"
            onClick={() => navigate("/")}
          />
        </div>

        {/* Center Section: Title - only shown on desktop */}
        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2">
          <span className="navbar-logo font-bold text-xl">
            PT Gema Mitra Suksesindo
          </span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6 text-lg font-serif items-center">
          {!admin ? (
            <>
              <a
                href="/"
                className="hover:text-gray-300 flex items-center gap-1"
              >
                <Home2 size="20" color="#fff" /> Home
              </a>
              <a
                href="/about"
                className="hover:text-gray-300 flex items-center gap-1"
              >
                <ProfileCircle size="20" color="#fff" /> About
              </a>
              <a
                href="/contact"
                className="hover:text-gray-300 flex items-center gap-1"
              >
                <CallCalling size="20" color="#fff" /> Contact
              </a>
            </>
          ) : (
            <>
              <a
                href={`/admin/products/${params.token}`}
                className="hover:text-gray-300 flex items-center gap-1"
              >
                <Box size="20" color="#fff" /> Products
              </a>
              <button
                onClick={() => {
                  navigate("/login/admin");
                  localStorage.removeItem("token_login");
                  sessionStorage.removeItem("token_login");
                }}
                className="hover:text-gray-300 flex items-center gap-1 bg-transparent border-none cursor-pointer"
              >
                <LogoutCurve size="20" color="#fff" /> Logout
              </button>
            </>
          )}
        </div>

        {/* Burger Icon for mobile */}
        <div className="md:hidden">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle Menu"
          >
            <svg
              className="w-7 h-7 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="mobile-menu md:hidden px-4 pb-4 text-white text-base font-serif space-y-2">
          {!admin ? (
            <>
              <a href="/" className="flex items-center gap-2">
                <Home2 size="18" color="#fff" /> Home
              </a>
              <a href="/about" className="flex items-center gap-2">
                <ProfileCircle size="18" color="#fff" /> About
              </a>
              <a href="/contact" className="flex items-center gap-2">
                <CallCalling size="18" color="#fff" /> Contact
              </a>
            </>
          ) : (
            <>
              <a
                href={`/admin/products/${params.token}`}
                className="flex items-center gap-2"
              >
                <Box size="18" color="#fff" /> Products
              </a>
              <button
                onClick={() => navigate("/login/admin")}
                className="flex items-center gap-2 bg-transparent border-none cursor-pointer"
              >
                <LogoutCurve size="18" color="#fff" /> Logout
              </button>
            </>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
